// Card #1652 (design §6.1/§6.2 types 6/7) — the ranked-list family's fixed
// banner copy. score-api's bannerFor (lib/scoreboard-mode-payload.js)
// already picked the exact string ("current class standings" for Mid-Class
// Result, "final class results" for End of Class Result, design §4.5/§6.2)
// — this component renders it verbatim, it never re-derives or rewords it.
import "./Banner.css";

export default function Banner({ banner }) {
  if (!banner) return null;

  return (
    <div className="scoreboard-banner" data-testid="banner">
      {banner}
    </div>
  );
}
